export const CSS = {
  button: "button",
};

export const ICONS = {
  plus: "plus",
};
